import { useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { useGetAgreementsToAccept } from 'src/shared/queries/useGetAgreementsToAccept';
import { useNavigateWithSecureParams } from './useNavigateWithSecureParams';

export const useAgreementsValidation = () => {
  const auth = useAuth();
  const { clearParams } = useNavigateWithSecureParams();
  const idToken = auth.user?.id_token || '';
  const { data, isFetching } = useGetAgreementsToAccept();
  const agreementsToAccept = data || [];
  const [isAllAgreementsAccepted, setIsAllAgreementsAccepted] = useState(false);
  const [isAgreementsModalVisible, setIsAgreementsModalVisible] = useState(true);

  const shouldShowPageContent = (!isFetching && agreementsToAccept.length === 0) || isAllAgreementsAccepted;

  const handleDeclineAgreements = () => {
    clearParams();
    auth.removeUser();
    auth.signoutRedirect({
      id_token_hint: idToken,
    });
  };

  const handleAcceptAgreements = () => {
    setIsAllAgreementsAccepted(true);
  };

  const closeAgreementsModal = () => {
    setIsAgreementsModalVisible(false);
  };

  return {
    agreementsToAccept,
    isAgreementsModalVisible,
    shouldShowPageContent,
    closeAgreementsModal,
    handleDeclineAgreements,
    handleAcceptAgreements,
  };
};
